import StandaloneOnly from './standalone-only.component';

export default StandaloneOnly;
